import { render, staticRenderFns } from "./IconProducts.vue?vue&type=template&id=a1d2d420"
import script from "./IconProducts.vue?vue&type=script&lang=js"
export * from "./IconProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports